import Marquee from "react-fast-marquee";

const WORDS = [
  "Maintenance générale",
  "Événementiel",
  "Plomberie",
  "Électricité",
  "Sonorisation",
  "Éclairage",
  "Effets spéciaux",
  "Dépannage rapide",
];

export default function KineticMarquee() {
  return (
    <section className="border-y border-white/10 bg-[#050505] py-8" data-testid="marquee">
      <Marquee speed={40} gradient={false} autoFill>
        {WORDS.map((w, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-8">
            <span className="stroke-text font-head text-5xl font-bold uppercase tracking-tight sm:text-7xl">
              {w}
            </span>
            <span className="text-3xl text-[#e63946]">✦</span>
          </span>
        ))}
      </Marquee>
    </section>
  );
}
